import React from 'react';
import { Box } from '@mui/material';

interface GridContainerProps {
  children: React.ReactNode;
  spacing?: number;
  alignItems?: string;
  sx?: Record<string, any>;
}

interface GridItemProps {
  children: React.ReactNode;
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  sx?: Record<string, any>;
}

export const GridContainer: React.FC<GridContainerProps> = ({ 
  children, 
  spacing = 2, 
  alignItems,
  sx = {}
}) => {
  return (
    <Box 
      sx={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(12, 1fr)', 
        gap: spacing, 
        alignItems,
        ...sx
      }}
    >
      {children}
    </Box>
  );
};

export const GridItem: React.FC<GridItemProps> = ({ 
  children, 
  xs = 12, 
  sm, 
  md, 
  lg, 
  xl,
  sx = {}
}) => {
  return (
    <Box 
      sx={{ 
        gridColumn: {
          xs: `span ${xs}`,
          ...(sm && { sm: `span ${sm}` }),
          ...(md && { md: `span ${md}` }),
          ...(lg && { lg: `span ${lg}` }),
          ...(xl && { xl: `span ${xl}` }),
        },
        ...sx
      }}
    >
      {children}
    </Box>
  );
};

export default { GridContainer, GridItem }; 